import { DialogContextProps } from "@interfaces/System/DialogContextProps";
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { ModalContentLoading } from "@components/Common/Modal";
import React, { useRef } from "react";
import { storeService } from "@services";
import { useSnackbar } from "notistack";
import { useAsync, useTable } from "@hooks";
import { CreateReserveStoreBindingDto, UpdateReserveStoreBindingDto } from "@dto/QuantityDto";
import { ReserveStoreBindingForm } from "@components/Forms/Quantity";

const ReserveStoreBindingDialogContext = ({ onClose, modalProps }: DialogContextProps) => {
    const { itemId } = { ...modalProps };

    const formRef = useRef<HTMLFormElement>();
    const { enqueueSnackbar } = useSnackbar();
    const { updateData } = useTable();

    const { data, loadingStatus } = useAsync(storeService.getOneReserveStoreBinding, {
        functionArgs: [itemId],
        canLoad: !!itemId,
    });

    const invokeSubmit = () => {
        formRef.current!.handleSubmit();
    };

    const handleCreateReserveStoreBinding = async (values) => {
        try {
            const dto = storeService.plainToClass(CreateReserveStoreBindingDto, values);
            await storeService.createReserveStoreBinding(dto);
            enqueueSnackbar("Привязка успешно добавлен", {
                variant: "success",
            });
            onClose();
            updateData();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при добавлении привязки", {
                variant: "error",
            });
        }
    };

    const handleUpdateReserveStoreBinding = async (values) => {
        if (!data) return;

        try {
            const dto = storeService.plainToClass(UpdateReserveStoreBindingDto, values);
            await storeService.updateReserveStoreBinding(data.id, dto);
            enqueueSnackbar("Привязка успешно обновлен", {
                variant: "success",
            });
            onClose();
            updateData();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при обновлении привязки", {
                variant: "error",
            });
        }
    };

    return (
        <>
            <DialogContent>
                {loadingStatus === "loading" && <ModalContentLoading />}

                {(loadingStatus === "loaded" || loadingStatus === "inactivity") && (
                    <ReserveStoreBindingForm
                        ref={formRef}
                        data={data}
                        onSubmit={
                            data ? handleUpdateReserveStoreBinding : handleCreateReserveStoreBinding
                        }
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onClose}>
                    Отмена
                </Button>
                <Button color="primary" variant="contained" onClick={invokeSubmit}>
                    Сохранить
                </Button>
            </DialogActions>
        </>
    );
};

export default ReserveStoreBindingDialogContext;
